module.exports = __webpack_public_path__ + "static/media/playbtn.6a918afd.svg";